import React from 'react';
import { AdSlot } from 'react-dfp';

import adCatalog from '../js/utils/adCatalog.json';
import '../css/ads.css';

class Ad extends React.Component {
  render() {
    const catalogEntry = adCatalog[this.props.adslot];

    if (!catalogEntry) {
      return <div>Invalid ad slot!</div>;
    }

    // Convert the size mapping to an object.
    const sizeMapping = [];
    let sizes = [];

    catalogEntry.sizeMapping.forEach(([viewport, theseSizes]) => {
      sizeMapping.push({ viewport, sizes: theseSizes });
      sizes = [...sizes, ...theseSizes];
    });

    return (
      <div className="ad-slot">
        <AdSlot
          sizeMapping={sizeMapping}
          sizes={sizes}
          targetingArguments={{
            pos: catalogEntry.pos,
          }}
          adUnit={this.props.section}
        />
      </div>
    );
  }
}

export default Ad;
